import { useCallback, useEffect, useState } from 'react';
import { singletonHook } from 'react-singleton-hook';

const defaultState: useOgTagsReturn = {
  set: () => null,
  setDefault: () => null,
  defaultTags: null,
  loaded: false,
  origin: '',
};
export const _useOgTagsImpl = () => {
  const [origin, setOrigin] = useState('');
  const [defaultTags, setDefaultTags] = useState<OgTags | null>(null);
  const [tags, setTags] = useState<OgTags | null>(null);

  useEffect(() => {
    setOrigin(document.location.origin);
  }, []);

  const setDefault = (tags: OgTags) => {
    setDefaultTags({ ...tags, image: `${document.location.origin}${tags?.image}` });
    //${origin}${tags?.image}
  };
  const set = useCallback(
    (tags: OgTags | null) => {
      if (!tags) {
        setTags(null);
      } else {
        setTags({ ...defaultTags, ...tags });
      }
    },
    [defaultTags],
  );

  return {
    set,
    setDefault,
    tags: tags || defaultTags,
    defaultTags,
    origin,
    loaded: true,
  };
};

export const useOgTags = singletonHook<useOgTagsReturn>(defaultState, _useOgTagsImpl, {
  unmountIfNoConsumers: false,
});
export interface useOgTagsReturn {
  set: (tags: OgTags | null) => void;
  setDefault: (tags: OgTags) => void;
  tags?: OgTags | null;
  defaultTags: OgTags | null;
  loaded?: boolean;
  origin: string;
}

type OgTags = {
  image?: string;
  title?: string;
  description?: string;
  image_width?: number;
  image_height?: number;
};
